<section class="centered-fullwidth py-14">
  @if (data.title; as title) {
    <div class="px-5 pb-7 desk:mb-[-100px] desk:w-[600px] desk:pb-7">
      <app-title [title]="title" size="h1" />
    </div>
  }
  @let stepClass = "relative bg-gray-light px-5 z-20 pt-10 flex flex-col gap-y-14 leading-none desk:px-24 desk:pt-0";
  @let step1 = data.step1;
  @let step2 = data.step2;
  @let step3 = data.step3;
  <ng-container *ngTemplateOutlet="pictosTemplate; context: { pictos: data.step1.pictos, isPriority: true }" />
  <ng-container *ngTemplateOutlet="blobTemplate; context: { zIndex: 10 }" />
  <div [class]="stepClass">
    <div #step1StyleEl class="flex flex-col gap-y-5 desk:mt-[-50px]">
      @let style = step1.style;
      <div class="font-title text-[25px]">{{ style.title }}</div>
      <ul class="grid grid-cols-2 gap-2 desk:grid-cols-4">
        @for (option of style.options; track option.id) {
          @let styleSelected = currentEstimate().styleSelected?.id === option.id;
          <li (click)="onOptionSelected('style', option)" class="h-[190px] cursor-pointer">
            <app-option-card-select
              [costLevel]="option.costLevel"
              [image]="option.image"
              [isPriority]="!isImageInPreviousBlocks && $index < 4"
              [name]="option.name"
              [selected]="styleSelected" />
          </li>
        }
      </ul>
    </div>
    <div #step1LayoutEl class="flex flex-col gap-y-5">
      @let implantation = step1.implantation;
      <div class="font-title text-[25px]">{{ implantation.title }}</div>
      <ul class="grid grid-cols-2 gap-2 desk:grid-cols-4">
        @for (option of implantation.options; track option.id) {
          @let layoutSelected = currentEstimate().layoutSelected?.id === option.id;
          <li (click)="onOptionSelected('layout', option)" class="h-[190px] cursor-pointer">
            <app-option-card-select [image]="option.image" [name]="option.name" [selected]="layoutSelected" />
          </li>
        }
      </ul>
    </div>
    <div #step1SizeEl class="flex flex-col gap-y-5">
      @let size = step1.size;
      <div class="font-title text-[25px]">{{ size.title }}</div>
      <ul class="grid grid-cols-2 gap-2 desk:grid-cols-4">
        @for (option of size.options; track option.id) {
          @let sizeSelected = currentEstimate().sizeSelected?.id === option.id;
          <li (click)="onOptionSelected('size', option)" class="h-[190px] cursor-pointer">
            <app-option-card-select
              [description]="option.description"
              [image]="option.image"
              [name]="option.name"
              [selected]="sizeSelected" />
          </li>
        }
      </ul>
    </div>
    <div #step1WorkPlanEl class="flex flex-col gap-y-5 desk:mb-[-50px]">
      @let workPlan = step1.workPlan;
      <div class="font-title text-[25px]">{{ workPlan.title }}</div>
      <ul class="grid grid-cols-2 gap-2 desk:grid-cols-4">
        @for (option of workPlan.options; track option.id) {
          @let workPlanSelected = currentEstimate().workPlanSelected?.id === option.id;
          <li (click)="onOptionSelected('workPlan', option)" class="h-[190px] cursor-pointer">
            <app-option-card-select
              [costLevel]="option.costLevel"
              [description]="option.description"
              [image]="option.image"
              [name]="option.name"
              [selected]="workPlanSelected" />
          </li>
        }
      </ul>
    </div>
  </div>
  <ng-container *ngTemplateOutlet="blobTemplate; context: { rotate180: true, zIndex: 20, flip: true }" />
  @if (showStep2()) {
    <div class="h-28"></div>
    <div #step2SinkTypeEl></div>
    <ng-container *ngTemplateOutlet="pictosTemplate; context: { pictos: data.step2.pictos, isPriority: false }" />
    <ng-container *ngTemplateOutlet="blobTemplate; context: { zIndex: 10, flip: true }" />
    <div [class]="stepClass">
      <div class="flex flex-col gap-y-5 desk:mt-[-50px]">
        @let sinkType = step2.sinkType;
        <div class="font-title text-[25px]">{{ sinkType.title }}</div>
        <ul class="grid grid-cols-2 gap-2 desk:grid-cols-4">
          @for (option of sinkType.options; track option.id) {
            @let sinkTypeSelected = currentEstimate().sinkTypeSelected?.id === option.id;
            <li (click)="onOptionSelected('sinkType', option)" class="h-[190px] cursor-pointer">
              <app-option-card-select
                [costLevel]="option.costLevel"
                [image]="option.image"
                [name]="option.name"
                [selected]="sinkTypeSelected" />
            </li>
          }
        </ul>
      </div>
      <div #step2HouseholdApplianceEl class="flex flex-col gap-y-5 desk:mb-[-50px]">
        @let householdAppliance = step2.householdAppliance;
        <div class="font-title text-[25px]">{{ householdAppliance.title }}</div>
        <ul class="grid grid-cols-2 gap-2 desk:grid-cols-4">
          @let noneSelected = currentEstimate().householdApplianceSelectedNone ?? false;
          <li (click)="onOptionSelected('householdAppliance', optionNone)" class="h-[190px] cursor-pointer">
            <app-option-card-select
              [name]="optionNone.name"
              [selected]="noneSelected"
              [showCheckbox]="true"
              class="pointer-events-none" />
          </li>
          @for (option of householdAppliance.options; track option.id) {
            @let selected = currentEstimate().householdApplianceSelected | someByProperty: "id" : option.id;
            <li (click)="onOptionSelected('householdAppliance', option)" class="h-[190px] cursor-pointer">
              <app-option-card-select
                [image]="option.image"
                [name]="option.name"
                [selected]="selected"
                [showCheckbox]="true"
                class="pointer-events-none" />
            </li>
          }
        </ul>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="blobTemplate; context: { rotate180: true, zIndex: 20 }" />
    @if (!showStep3Clicked()) {
      <div class="mt-[-30px] flex justify-center desk:mt-[-45px]">
        @let btnLabel = "ACTION.CONTINUE" | translate;
        <app-button (onButtonClick)="handleGoToStep3(btnLabel)" [buttonDisabled]="!showStep3()" [label]="btnLabel" />
      </div>
    }
  }
  @if (showStep3() && showStep3Clicked()) {
    <div class="h-28"></div>
    <div #step3InstallationEl></div>
    <ng-container *ngTemplateOutlet="pictosTemplate; context: { pictos: data.step3.pictos, isPriority: false }" />
    <ng-container *ngTemplateOutlet="blobTemplate; context: { zIndex: 10 }" />
    <div [class]="stepClass">
      <div class="flex flex-col gap-y-5 desk:my-[-50px]">
        @let installation = step3.installation;
        <div class="font-title text-[25px]">{{ installation.title }}</div>
        <ul class="grid grid-cols-2 gap-2 desk:grid-cols-4">
          @for (option of installation.options; track option.id) {
            @let installationSelected = currentEstimate().installationSelected?.id === option.id;
            <li (click)="onOptionSelected('installation', option)" class="h-[190px] cursor-pointer">
              <app-option-card-select
                [costLevel]="option.costLevel"
                [image]="option.image"
                [name]="option.name"
                [selected]="installationSelected" />
            </li>
          }
        </ul>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="blobTemplate; context: { rotate180: true, zIndex: 20, flip: true }" />
    <div class="mt-[-30px] flex justify-center desk:mt-[-45px]">
      @if (data.cta; as cta) {
        @if (this.estimateId()) {
          <app-button (onButtonClick)="goToRecap()" [buttonDisabled]="!canGoToEstimateSummary()" [label]="cta.label" />
        }
      }
    </div>
  }
</section>

<ng-template #blobTemplate let-flip="flip" let-rotate180="rotate180" let-zIndex="zIndex">
  <div
    [class.-scale-x-100]="flip"
    [class.mt-[-75px]]="!rotate180"
    [class.rotate-180]="rotate180"
    [style.z-index]="zIndex">
    <app-svg [inline]="true" src="assets/svgs/blob-estimator.svg" />
  </div>
</ng-template>
<ng-template #pictosTemplate let-isPriority="isPriority" let-pictos="pictos">
  <div class="pointer-events-none relative z-30 flex w-full justify-center desk:justify-end desk:px-24">
    @let picto1 = pictos[0];
    @let picto2 = pictos[1];
    @if (picto1.svg; as svg) {
      <app-svg [height]="152" [isPriority]="isPriority" [src]="svg" [width]="119" class="ml-1 rotate-[-7deg]" />
    }
    @if (picto2.svg; as svg) {
      <app-svg [height]="152" [isPriority]="isPriority" [src]="svg" [width]="119" class="-ml-1 rotate-6" />
    }
  </div>
</ng-template>
